export default __webpack_public_path__ + "static/media/628.441147af.png";